(function() {
    'use strict';
    angular.module('aprima-legacy-common').filter('apPersonThumbnailSrc', [
        'ServerInfoRepository',
        apPersonThumbnailSrc
    ]);

    function apPersonThumbnailSrc(
        ServerInfoRepository
    ) {
        return function (personId, height, width) {
            if (!personId || !ServerInfoRepository.isFeatureSupported([ 'PersonPhoto' ])) {
                // return undefined because a valid url can't be formed
                // and undefined can be handled accordingly
                return;
            }

            if (height && !width) {
                width = height;
            }

            var url = 'persons/' + personId + '/thumbnail';

            if (height) {
                url += '?height=' + height + '&width=' + width;
            }

            return url;
        };
    }
})();
